<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        (exportar)="onExportar($event)"
        [data]="produccionData"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'produccion'"
      [camposVisibles]="[
        'desde',
        'hasta',
        'ramo',
        'subramo',
        'tipoDoc',
        'selectFilter'
      ]"
      [sLobName]="getSlobName()"
      [lobName]="getLobName()"
      [documentTypeName]="getDocumentTypeName()"
      [camposObligatorios]="['desde', 'hasta']"
      (filterChange)="onFilterChange($event)"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="produccionData"
  [config]="tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [itemsPerPage]="pageSize"
  [serverSidePagination]="true"
  [totalRecordsFromServer]="totalRecordsFromServer"
  [totalPagesFromServer]="totalPagesFromServer"
  [totals]="tableTotals"
  (pageChange)="onPageChange($event)"
></app-insurance-table>
